// Module
var code = "<template> <section class=\"care-plan-view\"> <require from=\"app/cm/components/household/care-plan/care-plan\" as=\"household-careplan-view\"></require> <household-careplan-view household-case-id.bind=\"householdCaseId\"></household-careplan-view> </section> </template> ";
// Exports
module.exports = code;